import apiHandler from "../core/apiHandler";

const countryApi = apiHandler('countries');
export default countryApi;
